import Vue from 'vue'

export default {

  state: Vue.observable({
    orders: [],
    order: {},

    statuses: [],
  }),

  setOrder(order) {
    this.state.order = order
  },
  
  setOrders(orders) {
    this.state.orders = orders
  },

  updateOrder(newOrder) {
    this.state.orders = this.state.orders.map(order => {
      return order.id == newOrder.id ? newOrder : order
    })
  },

  //
  setStatuses(statuses) {
    this.state.statuses = statuses
  },
}
